import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';
import { useDesignerStore } from '../../store/designerStore.js';

const SectionWrapper = styled.section`
  /* Wird primär durch BaseWidget inlineStyles gesteuert */
  width: 100%;
  min-height: 50px;
  position: relative;
  /* Visualisierung, falls komplett leer, damit man es anklicken kann */
  ${props => !props.$isLiveMode && props.$isEmpty && `
    background: rgba(0, 169, 224, 0.03);
    border: 1px dashed rgba(0, 169, 224, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    
    &::after {
      content: 'Leere Sektion (Drag & Drop Elemente hierher)';
      color: #718096;
      font-size: 13px;
    }
  `}
`;

export function Section({ node, children, isLiveMode }) {
  const addNode = useDesignerStore(state => state.addNode);
  const isDragging = useDesignerStore(state => state.isDragging);
  const isEmpty = !children || children.length === 0;

  const handleDragOver = (e) => {
    if (isLiveMode) return;
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'copy';
  };

  const handleDrop = (e) => {
    if (isLiveMode) return;
    e.preventDefault();
    e.stopPropagation();
    
    const widgetType = e.dataTransfer.getData('tef-designer/widget-type');
    if (widgetType) {
      addNode(widgetType, node.id); // In dieser Sektion als Kind einfügen
    }
  };

  return (
    <SectionWrapper 
      $isLiveMode={isLiveMode} 
      $isEmpty={isEmpty}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      style={{
        boxShadow: (isDragging && !isLiveMode) ? 'inset 0 0 0 2px rgba(0, 169, 224, 0.3)' : 'none'
      }}
    >
      {children}
    </SectionWrapper>
  );
}

// === WIDGET REGISTRIERUNG ===
registry.register('Section', {
  label: 'Sektion',
  icon: '🟦',
  category: 'layout',
  component: Section,
  defaultProps: {
    style: {
      desktop: {
        padding: '40px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        width: '100%',
        boxSizing: 'border-box'
      }
    }
  },
  inspectorControls: [
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout & Anzeige',
          fields: [
            { name: 'style.desktop.display', type: 'select', label: 'Display', options: ['block', 'flex', 'grid'] },
            { name: 'style.desktop.flexDirection', type: 'select', label: 'Richtung (Flex)', options: ['row', 'column'] },
            { name: 'style.desktop.gap', type: 'text', label: 'Abstand Innen (Gap)' }
          ]
        },
        {
          title: 'Hintergrund',
          fields: [
            { name: 'style.desktop.backgroundColor', type: 'color', label: 'Hintergrundfarbe' }
          ]
        }
      ]
    },
    {
      tab: 'advanced',
      groups: [
        {
          title: 'Abstände',
          fields: [
            { name: 'style.desktop.padding', type: 'text', label: 'Padding' },
            { name: 'style.desktop.margin', type: 'text', label: 'Margin' }
          ]
        }
      ]
    }
  ]
});
